import { render, staticRenderFns } from "./IconSortUp.vue?vue&type=template&id=47274674&"
import script from "./IconSortUp.vue?vue&type=script&lang=js&"
export * from "./IconSortUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports